import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { handleTypeConversion } from './handleTypeConversion';
export function handleReturnTypeAssignment(context, expr) {
    const func = tsUtils.node.getFirstAncestorByTestOrThrow(expr, ts.isFunctionLike);
    const funcReturnType = context.analysis.getFunctionReturnType(func, { error: true });
    const exprType = context.analysis.getType(expr);
    if (funcReturnType !== undefined && exprType !== undefined) {
        handleTypeConversion(context, expr, exprType, func, funcReturnType);
    }
}

//# sourceMappingURL=handleReturnTypeAssignment.js.map
